import { gravar_retrato_matricula_para_o_censo } from "./gravar-retrato-matricula-para-o-censo/index";
import { consulta_de_retrato_de_matricula_do_censo } from "./consulta-de-retrato-de-matricula-do-censo/index";
import { atualizar_retrato_matriculas_com_situacao_do_aluno } from "./atualizar-retrato-matriculas-com-situacao-do-aluno/index";

const retrato_para_censo = [
  ...gravar_retrato_matricula_para_o_censo,
  ...consulta_de_retrato_de_matricula_do_censo,
  ...atualizar_retrato_matriculas_com_situacao_do_aluno,
];

export { retrato_para_censo };
